import { useState, useEffect } from 'react';
import NAV_CONFIG from '../data/navConfig';

export default function useNav(initial = 'dashboard', role = null) {
  const [active, setActive] = useState(() => {
    const saved = sessionStorage.getItem('maaze_active_page');
    if (role === 'Organiser' && saved === 'dashboard') return 'organiserDashboard';
    if (role === 'Owner' && saved === 'organiserDashboard') return 'dashboard';
    return saved || initial;
  });

  useEffect(() => {
    if (role && !sessionStorage.getItem('maaze_active_page')) {
      const defaultPage = role === 'Organiser' ? 'organiserDashboard' : 'dashboard';
      setActive(defaultPage);
      sessionStorage.setItem('maaze_active_page', defaultPage);
    }
  }, [role]);
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleSidebar = () => {
    setCollapsed((c) => !c);
    setMobileOpen((m) => !m);
  };

  const navigate = (id) => {
    setActive(id);
    sessionStorage.setItem('maaze_active_page', id);
    setMobileOpen(false);
  };
  const filteredNav = NAV_CONFIG.map(section => ({
  ...section,
  items: section.items.filter(item => {
    // ✅ If role not ready yet → hide role-based items
    if (!role && item.role) return false;

    if (!item.role) return true;

    // return item.role.includes(role);
    return role && item.role.includes(role.toLowerCase());
  })
})).filter(section => section.items.length > 0);

  // ✅ THEN use it
  const activeItem = filteredNav
    .flatMap((s) => s.items)
    .find((i) => i.id === active);

  const activeSection = filteredNav
    .find((s) => s.items.some((i) => i.id === active))?.section;

  return {
    active,
    collapsed,
    mobileOpen,
    toggleSidebar,
    navigate,
    activeItem,
    activeSection,
    navConfig: filteredNav
  };
}